/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations, useTexture } from '@react-three/drei'
import * as THREE from 'three'

export default function Coin(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/eCoin/coinElow2.glb')
  const { actions } = useAnimations(animations, group)

  useEffect(() => {
    console.log("materials", materials , nodes)
  }, [])

  // Load all the PBR textures from the new coin model
  const textures = useTexture({
    map: '/eCoin/basecolor.jpg',
    normalMap: '/eCoin/normal.jpg',
    roughnessMap: '/eCoin/rough.jpg',
    metalnessMap: '/eCoin/rough.jpg',
    aoMap: '/eCoin/basecolor.jpg',
  })
  const textures2 = useTexture({
    map: '/eCoin/specu.jpg',
    normalMap: '/eCoin/normal.jpg',
    roughnessMap: '/eCoin/rough.jpg',
    metalnessMap: '/eCoin/rough.jpg',
    aoMap: '/eCoin/specu.jpg',
  })

  // const textures3 = useTexture({
  //   map: '/coinExport/basecolor.jpg',
  //   normalMap: '/coinExport/others_0018_normal_opengl_2k.png',
  //   roughnessMap: '/coinExport/Metallic-Rough.png',
  //   metalnessMap: '/coinExport/Metallic-Rough.png',
  //   aoMap: '/coinExport/basecolor.jpg',
  // })

  // Create a custom material using the loaded textures
  const customMaterial = new THREE.MeshStandardMaterial({
    ...textures,
    metalness: 1,
    roughness: .5,
  })

  const customMaterial2 = new THREE.MeshStandardMaterial({
    ...textures2,
    metalness: 1,
    roughness: 1,
  })

  useEffect(() => {
    console.log(materials)
  }, [])

  return (
    <group {...props} dispose={null}>
      <group position={[0, 1, 0]} rotation={[0, 0, Math.PI]}>
        <mesh geometry={nodes.mesh.geometry} material={customMaterial} rotation={[Math.PI / -2, 0, 0]} />
        <mesh geometry={nodes.mesh_1.geometry} material={customMaterial2} rotation={[Math.PI / -2, 0, 0]} />
      </group>
    </group>
  )
}

useGLTF.preload('/eCoin/coinElow2.glb')
